import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useDocsPreview = (): IGlobalStore['docs_preview'] => {
  return useSelector((store: IReducerStore) => store.global.docs_preview);
};
